import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

interface LocationState {
  success?: boolean;
  message?: string;
  bookingId?: string;
}

const ConfirmationPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = (location.state || {}) as LocationState;

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <div className="container mx-auto px-4 py-12 flex-grow">
        <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-md p-8 text-center">
          <CheckCircle size={56} className="mx-auto text-green-500 mb-4" />
          <h1 className="text-2xl font-bold text-gray-900 mb-2">{state.success ? 'Reserva Confirmada' : 'Reserva'}</h1>
          <p className="text-gray-600 mb-6">{state.message || 'Gracias por tu reserva. Hemos enviado los detalles a tu correo.'}</p>

          {state.bookingId && (
            <div className="bg-gray-50 border border-gray-100 rounded-lg p-4 mb-4">
              <p className="text-sm text-gray-700">ID de reserva: <span className="font-medium">{state.bookingId}</span></p>
            </div>
          )}

          <div className="flex justify-center space-x-4">
            <button
              onClick={() => navigate('/bookings')}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 cursor-pointer"
            >
              Ver mis reservas
            </button>
            <button
              onClick={() => navigate('/')}
              className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-300 cursor-pointer"
            >
              Volver al inicio
            </button>
          </div>
        </div>
  </div>
    </div>
  );
};

export default ConfirmationPage;
